// isomorphic-dompurify: DOMPurify in the browser, DOMPurify + jsdom on the
// server, so server-rendered pages are sanitized the same way.
import DOMPurify from "isomorphic-dompurify";

/**
 * Sanitize HTML that comes from the API (CKEditor articles, webinar bodies,
 * report bios, notification descriptions) before it reaches
 * dangerouslySetInnerHTML.
 *
 * DOMPurify's defaults already drop <script>, <iframe>, inline event handlers
 * and javascript: URLs while keeping the formatting CKEditor produces
 * (headings, lists, links, images, tables). On top of that we keep `target`
 * and force a safe `rel` on links that open a new tab.
 */
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export const sanitizeHtml = (html: string | null | undefined): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
};
